import {
  Box,
  Button,
  // Checkbox,
  FormControl,
  IconButton,
  // MenuItem,
  Typography,
  // Select as MuiSelect,
} from '@mui/material';
// import { styled } from '@mui/material/styles';
import DeleteIconRed from '@root/assets/svg/Authentication/DeleteIconRed';
import isEmpty from 'lodash/isEmpty';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@root/components/v3/select';
import {
  MultiSelect,
  MultiSelectContent,
  MultiSelectItem,
  MultiSelectTrigger,
  MultiSelectValue,
} from '@root/components/v3/multi-select';

const typographyStyles = {
  fontSize: '14px',
  fontWeight: 500,
  color: '#1A202C',
  display: 'inline-block',
  marginLeft: '4px',
  fontFamily: 'Manrope',
  marginBottom: '8px',
};

const GroupSelect = ({ severities, groups, setGroups, configs, repos }) => {
  const handleChange = (groupIdx, key, value) => {
    const updated = [...groups];
    updated[groupIdx][key] = value;
    setGroups(updated);
  };

  const addGroup = () => {
    setGroups(prev => [
      ...prev,
      {
        repos: '',
        cve: ['Critical'],
        iac: ['Critical'],
        secret: ['Active', 'Inactive'],
      },
    ]);
  };
  const removeGroup = index => {
    setGroups(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <Box>
      {groups.map((group, idx) => (
        <Box
          key={idx}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // gap:'24'
            gap: 2,
            justifyContent: 'center',
            mb: '30px',
          }}>
          {/* Select 1 - single select */}
          {repos && !isEmpty(repos) && (
            <FormControl sx={{ display: 'flex', flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography sx={typographyStyles}>Select Branch</Typography>
                <IconButton
                  onClick={() => removeGroup(idx)}
                  disabled={groups.length === 1}
                  aria-label="remove"
                  sx={{
                    display: idx !== 0 ? 'block' : 'none',
                  }}
                  color="error">
                  <DeleteIconRed />
                </IconButton>
              </Box>

              <Select value={group.repos} onValueChange={value => handleChange(idx, 'repos', value)}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select Repo" />
                </SelectTrigger>
                <SelectContent>
                  {repos?.map(cluster => (
                    <SelectItem key={cluster.value} value={cluster.value}>
                      {cluster.value}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>

              {/* <CustomSelect
                value={group.repos}
                displayEmpty
                onChange={e => handleChange(idx, 'repos', e.target.value)}
                renderValue={selected =>
                  selected === '' ? <span className="inner-placeholder">Select Repo</span> : selected
                }>
                {repos.map(opt => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </CustomSelect> */}
            </FormControl>
          )}

          {/* Select 2 - multi-select */}
          <Box sx={{ display: 'flex', flex: 1, gap: '30px', alignItems: 'center' }}>
            <FormControl fullWidth sx={{ minWidth: 150 }}>
              <Typography sx={typographyStyles}>Select CVE alert</Typography>
              <MultiSelect values={group.cve} onValuesChange={value => handleChange(idx, 'cve', value)}>
                <MultiSelectTrigger className="w-full font-manrope">
                  <MultiSelectValue placeholder="Select Severity" className="font-manrope" />
                </MultiSelectTrigger>
                <MultiSelectContent search={false} className="z-[1000001]">
                  {severities?.map(cluster => (
                    <MultiSelectItem key={cluster.value} value={cluster.value}>
                      {cluster.label}
                    </MultiSelectItem>
                  ))}
                </MultiSelectContent>
              </MultiSelect>
              {/* <CustomSelect
                multiple
                value={group.cve}
                displayEmpty
                onChange={e => handleChange(idx, 'cve', e.target.value)}
                renderValue={selected =>
                  selected.length === 0 ? (
                    <span className="inner-placeholder">Select Severity</span>
                  ) : (
                    selected.join(', ')
                  )
                }>
                {severities.map(opt => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox checked={group.cve.indexOf(opt.value) > -1} sx={{ padding: '0 8px 0 0' }} />
                    {opt.label}
                  </MenuItem>
                ))}
              </CustomSelect> */}
            </FormControl>

            {/* Select 3 - multi-select */}
            <FormControl fullWidth sx={{ minWidth: 150 }}>
              <Typography sx={typographyStyles}>Select IAC alert</Typography>
              <MultiSelect values={group.iac} onValuesChange={value => handleChange(idx, 'iac', value)}>
                <MultiSelectTrigger className="w-full font-manrope">
                  <MultiSelectValue placeholder="Select Severity" className="font-manrope" />
                </MultiSelectTrigger>
                <MultiSelectContent search={false} className="z-[1000001]">
                  {severities?.map(cluster => (
                    <MultiSelectItem key={cluster.value} value={cluster.value}>
                      {cluster.label}
                    </MultiSelectItem>
                  ))}
                </MultiSelectContent>
              </MultiSelect>
              {/* <CustomSelect
                multiple
                value={group.iac}
                displayEmpty
                onChange={e => handleChange(idx, 'iac', e.target.value)}
                renderValue={selected =>
                  selected.length === 0 ? (
                    <span className="inner-placeholder">Select Severity</span>
                  ) : (
                    selected.join(', ')
                  )
                }>
                {severities.map(opt => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox checked={group.iac.indexOf(opt.value) > -1} sx={{ padding: '0 8px 0 0' }} />
                    {opt.label}
                  </MenuItem>
                ))}
              </CustomSelect> */}
            </FormControl>

            <FormControl fullWidth sx={{ minWidth: 150 }}>
              <Typography sx={typographyStyles}>Select Secret Config</Typography>
              <MultiSelect values={group.secret} onValuesChange={value => handleChange(idx, 'secret', value)}>
                <MultiSelectTrigger className="w-full font-manrope">
                  <MultiSelectValue placeholder="Select Config" className="font-manrope" />
                </MultiSelectTrigger>
                <MultiSelectContent search={false} className="z-[1000001]">
                  {configs?.map(opt => (
                    <MultiSelectItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MultiSelectItem>
                  ))}
                </MultiSelectContent>
              </MultiSelect>
              {/* <CustomSelect
                multiple
                value={group.secret}
                displayEmpty
                onChange={e => handleChange(idx, 'secret', e.target.value)}
                renderValue={selected =>
                  selected.length === 0 ? <span className="inner-placeholder">Select Config</span> : selected.join(', ')
                }>
                {configs.map(opt => (
                  <MenuItem key={opt.value} value={opt.value}>
                    <Checkbox checked={group.secret.indexOf(opt.value) > -1} sx={{ padding: '0 8px 0 0' }} />
                    {opt.label}
                  </MenuItem>
                ))}
              </CustomSelect> */}
            </FormControl>
          </Box>
        </Box>
      ))}

      {!isEmpty(repos) && groups.length < repos.length && (
        <Button variant="contained" onClick={addGroup}>
          Add More
        </Button>
      )}
    </Box>
  );
};

export default GroupSelect;
